import React from 'react'

import { PriceString, ProfitString } from '@fourthwall/components'
import type {
  BillingOrderCostsBreakdown,
  BillingOrderCostsBreakdownEntries,
} from '@fourthwall/services/dist/BillingApiClient'

import { BreakdownSection } from './components/BreakdownSection'
import * as S from './styled'

export type CostsBreakdownProps = {
  costsBreakdown: BillingOrderCostsBreakdown
}

const renderSection = (
  title: string,
  costsBreakdownItem?: BillingOrderCostsBreakdownEntries,
  negative = false,
  displayprofit = false,
) => {
  if (!costsBreakdownItem) {
    return null
  }

  return (
    <BreakdownSection
      title={title}
      cost={
        costsBreakdownItem.cost &&
        (displayprofit ? (
          <ProfitString value={costsBreakdownItem.cost.value} />
        ) : (
          <PriceString value={costsBreakdownItem.cost.value} negative={negative} />
        ))
      }
      overriddenCost={
        costsBreakdownItem.overriddenCost && (
          <PriceString value={costsBreakdownItem.overriddenCost.value} negative={negative} />
        )
      }
      tooltipContent={costsBreakdownItem.explanation}
      entries={costsBreakdownItem.entries}
    />
  )
}

export const CostsBreakdown = ({ costsBreakdown }: CostsBreakdownProps) => {
  const incomeTitle = costsBreakdown.total.refund
    ? 'Initial payment by supporter'
    : 'Paid by supporter'
  const refundTitle = {
    Cancel: 'Refunded',
    RefundByCreator: 'Refunded by you',
    RefundByFourthwall: 'Refunded by Fourthwall',
  }[costsBreakdown.total.refundCause || 'Cancel']

  return (
    <S.Container>
      {renderSection('Fulfillment fees', costsBreakdown.fulfillmentFee, true)}
      {renderSection('Product manufacturing costs', costsBreakdown.offers, true)}
      {renderSection('Digital products fees', costsBreakdown.digitals, true)}
      {renderSection('Payment processing fees', costsBreakdown.paymentFee, true)}
      {renderSection('Custom insert fee', costsBreakdown.thankYouCardFee, true)}
      {renderSection('Donation to charity', costsBreakdown.pledgeDonationCost, true)}
      {renderSection('Shipping', costsBreakdown.shipping, true)}
      {renderSection('Taxes', costsBreakdown.tax, true)}
      <S.Summary>
        {renderSection('Total costs', costsBreakdown.total.cost, true)}
        {renderSection(incomeTitle, costsBreakdown.total.income)}
        {renderSection(refundTitle, costsBreakdown.total.refund, true)}
        {renderSection('Net payment by supporter', costsBreakdown.total.supporterNetPayment)}
      </S.Summary>
      <S.Summary>
        {renderSection('Your profit', costsBreakdown.total.profit, undefined, true)}
        {renderSection('Prepayment balance', costsBreakdown.prepaymentBalance, true)}
      </S.Summary>
    </S.Container>
  )
}
